import * as React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from "primereact/button";
import AlertMessage from '../../../common/components/alertMessage/alertMessage';
import { InputText } from 'primereact/inputtext';
import { FoodAlcoholModel } from "../../../models/foodAndAlcohol";
import { InputTextarea } from 'primereact/inputtextarea';
import * as HelperFunctions from '../../../common/functions/helperFunctions';
import Language from '../../../common/components/language/language';
import { Lang } from '../../../common/enums';

interface IProps {
  saveClick: any,
  cancelClick: any,
  isVisible: boolean,
  currentfoodAlcohol: FoodAlcoholModel
}

interface IState {
  foodAlcohol: FoodAlcoholModel,
  validationMessage: string,
  selectedLangId: number
}

class FoodAlcoholAddEditDialog extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);

    this.state = {
      foodAlcohol: props.currentfoodAlcohol,
      validationMessage: '',
      selectedLangId: Lang.bg
    };
  }

  handleChange = (key, value) => {
    const foodAlcohol: FoodAlcoholModel = { ...this.state.foodAlcohol };
    foodAlcohol[key] = value;
    this.setState({ foodAlcohol: { ...foodAlcohol } });
  };

  isValidAddEditForm() {
    let message = '';

    this.setState({
      validationMessage: ''
    });

    if (!this.state.foodAlcohol.foodAlcoholContent.some(r => r.foodAndAlcoholName != null)) {
      message += "Please enter 'BG name' or 'En name'.<br />";
    }

    this.setState({
      validationMessage: message
    });

    return message == '';
  }

  handleSaveButton = event => {
    event.preventDefault();

    if (!this.isValidAddEditForm()) return;

    const foodAlcohol = this.state.foodAlcohol;

    this.props.saveClick(foodAlcohol);
  }

  handleCanselButton = () => {
    this.props.cancelClick();
  }

  onLangChange = (lang) => {
    this.setState({ selectedLangId: lang });
  }

  getValueContent = (key) => {
    let content = this.state.foodAlcohol.foodAlcoholContent.find(r => r.langId == this.state.selectedLangId)
    if (content && content[key]) {
      return content[key];
    }
    return '';
  }

  handleChangeContent = (key, value) => {
    const foodAndAlcohol: FoodAlcoholModel = { ...this.state.foodAlcohol };
    let content = foodAndAlcohol.foodAlcoholContent.find(r => r.langId == this.state.selectedLangId);
    if (content) {
      content[key] = value;
    }
    this.setState({ foodAlcohol: { ...foodAndAlcohol } });
  };

  public render() {

    const { foodAlcohol, selectedLangId } = this.state;

    return (

      <Dialog header="Food and Alcohol Form" responsive={true} width="50%"
        modal={true}
        visible={this.props.isVisible}
        onHide={this.handleCanselButton}
        footer={
          <div>
            <Button label="Save" icon="pi pi-check" onClick={this.handleSaveButton} className="p-button-raised" />
            <Button label="Cancel" icon="pi pi-times" onClick={this.handleCanselButton} className="p-button-secondary p-button-raised" />
          </div>}
      >
        <div style={{ minHeight: '450px', maxHeight: '650px' }}>

          {this.state.validationMessage ? <AlertMessage type='danger'>{this.state.validationMessage}</AlertMessage> : null}
          <div className="p-grid p-fluid">
            <Language selectedLang={selectedLangId} onLangChange={this.onLangChange}></Language>
            <div className="p-g-12 p-md-12">
              <label>Name:</label>
              <InputText
                name="foodAndAlcoholName"
                onChange={(e) => this.handleChangeContent('foodAndAlcoholName', e.target['value'])}
                value={this.getValueContent('foodAndAlcoholName')}
              />
            </div>
            <div className="p-g-12 p-md-12">
              <label>Description:</label>
              <InputTextarea rows={5} cols={30}
                onChange={(e) => this.handleChangeContent('description', e.target['value'])}
                value={this.getValueContent('description')}
              />
            </div>
          </div>

        </div>
      </Dialog >
    )
  }
}

export default FoodAlcoholAddEditDialog;